'use client';
import { useEffect } from 'react';
import { Slide, Stack } from '@mui/material';
import { BannerContainer } from './styles';
import { LabelLarge } from '../../styles';
import { useBreakpoint, useNavigateTo, useToggle } from '../../hooks';
import { isCompact } from '../../types';
import { OutlinedButton } from '../buttons';
import { useTheme } from '@emotion/react';
import { ROUTES } from '../../../constants';
import { getCookieValue, setCookie } from '../../utils';
import { useTranslations } from 'next-intl';

export const CookieBanner = () => {
    const breakpoint = useBreakpoint();
    const theme = useTheme();
    const t = useTranslations('general');
    const isCompactScreen = isCompact(breakpoint);
    const navigateTo = useNavigateTo();

    const [hasAccepted, setHasAccepted] = useToggle(false);
    const [animation, setAnimation] = useToggle(false);

    useEffect(() => {
        setAnimation(true);
        const hasAcceptedValue = getCookieValue('hide_cookie');
        if (hasAcceptedValue === '1') setHasAccepted(true);
    });

    const onAccept = () => {
        setCookie('hide_cookie', '1', 30);
        setHasAccepted(true);
    };

    if (hasAccepted) {
        return null;
    }

    const renderButton = (label: string, onClick: () => void) => {
        return (
            <OutlinedButton
                onClick={onClick}
                label={label}
                labelColor={theme.colors.surface}
                style={{ borderColor: theme.colors.surface, borderRadius: theme.spacing(0.5) }}
                fullWidth
            />
        );
    };

    return (
        <Slide in={animation} direction='up'>
            <BannerContainer>
                <Stack
                    direction={isCompactScreen ? 'column' : 'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    width={'100%'}
                    gap={isCompactScreen ? 1 : 3}
                >
                    <LabelLarge style={{ color: theme.colors.surface }}>
                        {t('cookie_disclaimer')}
                    </LabelLarge>
                    <Stack
                        direction={isCompactScreen ? 'column' : 'row'}
                        width={isCompactScreen ? '100%' : 'auto'}
                        gap={isCompactScreen ? 1 : 3}
                    >
                        {renderButton(t('cookie_details'), () => navigateTo(ROUTES.Privacy))}
                        {renderButton(t('cookie_accept'), onAccept)}
                    </Stack>
                </Stack>
            </BannerContainer>
        </Slide>
    );
};
